import {
  ErrorDialogContext,
  errorHandledSync,
} from "@/shared/context/error-context";
import { InstitutionsServicesService } from "@/features/institutions/services/institutions-services-service";
import { useContext } from "react";
import { useInstitutionsContext, InstitutionsService } from "@/features/institutions/contexts/institutions-context";


export const useInstitutionsServices = () => {
  const {
    setInstitutionsServices,
  } = useInstitutionsContext();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const institutionsServicesService = new InstitutionsServicesService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関サービス一覧取得
  const getInstitutionsServices = async (
    industryCode: string,
    companyCode: string,
    branchCode?: string,
  ): Promise<InstitutionsService[]> => {
    try {
      const res = await institutionsServicesService.getInstitutionsServices({
        industry_code: industryCode,
        company_code: companyCode,
        ...(branchCode !== "" && { branch_code: branchCode }),
      });

      const institutionsServiceList = res.map((item) => ({
          industryCode: item.industry_code,
          industryName: item.industry_name,
          companyCode: item.company_code,
          companyName: item.company_name,
          branchCode: item.branch_code,
          branchName: item.branch_name,
          serviceCode: item.service_code,
          serviceName: item.service_name,
          maintenanceType: item.maintenance_type,
          scrapeType: item.scrape_type,
          sortOrder: item.sort_order,
          siteUriLink: item.site_uri_link,
          idInputComment: item.id_input_comment,
          branchNameInputYn: item.branch_name_input_yn,
          branchNameInputTitle: item.branch_name_input_title,
          branchNameInputValidYn: item.branch_name_input_valid_yn,
          enginScrapYn: item.engin_scrap_yn,
          idInputYn: item.id_input_yn,
          idInputTitle: item.id_input_title,
          idInputValidYn: item.id_input_valid_yn,
          id2InputYn: item.id2_input_yn,
          id2InputTitle: item.id2_input_title,
          id2InputValidYn: item.id2_input_valid_yn,
          pwdInputYn: item.pwd_input_yn,
          pwdInputTitle: item.pwd_input_title,
          pwdInputValidYn: item.pwd_input_valid_yn,
          pwd2InputYn: item.pwd2_input_yn,
          pwd2InputTitle: item.pwd2_input_title,
          pwd2InputValidYn: item.pwd2_input_valid_yn,
      }));
      setInstitutionsServices(institutionsServiceList);
      return institutionsServiceList;
    } catch (error) {
      // エラーハンドリング
      console.log("setInstitutionsServices", error)
      throw error;
      // return [];
    } finally {
      //
    }
  };


  return {
    getInstitutionsServices: errorHandledSync(getInstitutionsServices, setError),
  };
};
